import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';

import { AppContext } from "../../Context";
import Popups from "../../components/Pop";
import QuestionsList from './components/questionsList'
import Fetch, { Loader, GET } from "../../inc/Fetch";
import QuestionAdd from '../popups/QuestionAdd'
import { Input, SelectBox, ClassesDropdown, RichText, UploadForm, MultiSelect, MultiSelecNew } from '../../components/Form'

import './css/sendTask.css'

export default function Send() {
    
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();


    const { successData } = useContext(AppContext);
    const [open, setopen] = successData;

    const maxTabs = 4;
    const [task, settask] = useState({});
    const [questions, setquestions] = useState([]);
    const [loader, setloader] = useState(true);
    const [loading, setloading] = useState(false);
    const [tab, settab] = useState(1);
    const [values, setvalues] = useState({ _id: params?.id });
    const [Open, setOpen] = useState();
    const [allStudents, setallStudents] = useState([]);
    const [students, setstudents] = useState([]);
    
    const SortableContainerElem = SortableContainer(({children}) => {
        return <>{children}</>;
    }, [questions]);

    const saveSort = (o, n) => {

        function array_move(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; 
        };


        let arr = [];
        let sort = [];
        let sortList = array_move(questions, o?.oldIndex, o?.newIndex);
        if (sortList) {
            sortList?.map((v) => {
                v.hash = Math.floor(Math.random() * 999999999999999);
                arr.push(v);
                sort.push(v?._id);
            });
        }

        setquestions(arr);
        // console.log(arr);
        

        // setvalues(arr);

        // Fetch("plugs/sort", (d) => {
            
        //     console.log(d);
            
        // }, { sort: sort, table: data?.id });

    }

    const SortableItem = SortableElement(({v, k}) => {

        return (
            <QuestionsList v={v} k={k + 1} key={k} setOpen={setOpen} setquestions={setquestions}/>
        
        )
    });
    
    async function loadData() {
        if (params?.task) {
            let res = await GET("/task/viewMyTask?_id=" + params?.task);

            let stud = [];
            res?.students?.map(v => {
                stud?.push({ name: v?.name, _id: v?._id, classes: v?.classes[0] });
            });

            setallStudents(stud);
            
            setquestions(res?.task?.questions);
            setvalues(p => ({
                ...p,
                story:res?.task?.story,
                title:res?.task?.title,
                classes:[res?.task?.classes],
                timer:res?.task?.timer,
                start_date: res?.task?.start_date ? new Date(res?.task?.start_date).toISOString().slice(0,16) : false,
                end_date: res?.task?.end_date ? new Date(res?.task?.end_date).toISOString().slice(0,16) : false,
                notes: res?.task?.notes,
            }));
            setloader(false);

        } else {

            
            
            if (location?.state?.questions) {
                
                setquestions(location?.state?.questions);
            } else {
                
                let res = await GET("/task/loadTask?_id=" + params?.id); 
                setquestions(res?.task?.questions);
                
                setvalues(p => ({
                    ...p,
                    story:res?.task?.story,
                    title:res?.task?.title
                }));

                // setallStudents(res?.students);

                let stud = [];
                res?.students?.map(v => {
                    stud?.push({ name: v?.name, _id: v?._id, classes: v?.classes[0] });
                });

                setallStudents(stud);
                
            }
            
            setloader(false);
        }

    }
    
    function submit(){ 

        setloading(true);
        Fetch("task/send", (d) => {

            if (d?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {

                setopen({ error:false, short:t("tasks_sent_success") });

                setTimeout(() => {
                    // navigate(`/task/${d?.success?._id}`)
                    navigate(-1)
                }, 2500);
            }
            
            setloading(false);
        }, { values:values, questions:questions, task:params?.task });
    }

    function nextBack(t) {

        if (t) {
            checkValues(tab <= 1 ? 1 : tab - 1)
        } else {
            checkValues(tab >= maxTabs ? maxTabs : tab + 1)
        }
    }

    function checkValues(d) {
        let res = false;

        if (d == 2) {
            if (!questions?.length) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[17]});
                return false;
            }
        }
        if (d == 3) { 
            if (!questions?.length) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[17]});
                return false;
            }

            if (!questions?.length) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[17]});
                return false;
            }
            if (!values?.title) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[4]});
                return false;
            }
            
            if (!values?.classes?.length) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[5]});
                return false;
            }
        }
        if (d == 4) {
            if (!questions?.length) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[17]});
                return false;
            }
            if (!values?.title) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[4]});
                return false;
            }
            if (!values?.classes?.length) {
                setopen({ error: true, short: t("error",  { returnObjects: true })[5]});
                return false;
            }
            
        }

        settab(d);
     
    }


    useEffect(() => {
        if (values?.classes?.length) {

            let stu = [];
            values?.classes?.map(v => {
                let ck = allStudents?.filter(r => r?.classes == v);
                ck?.map(v2 => {
                    stu.push(v2);
                });

            });

            setstudents(stu);
        } else {
            setstudents([]);
        }
        
    }, [values?.classes]);

    useEffect(() => {
        loadData();
    }, [])
    
    if (loader) {
        return <Loader />
    }

    const timingLimit = [
        {
            name: `--`,
            val: false,
        },
        {
            name: t("tasks_send_time_limit_10"),
            val: 10,
        },
        {
            name: t("tasks_send_time_limit_20"),
            val: 20,
        },
        {
            name: t("tasks_send_time_limit_30"),
            val: 30,
        },
        {
            name: t("tasks_send_time_limit_45"),
            val: 45,
        },
        {
            name: t("tasks_send_time_limit_60"),
            val: 60,
        },
        {
            name: t("tasks_send_time_limit_90"),
            val: 90,
        }
    ];

    
    return (
        <>
            {loading && <Loader />}
            {Open && <QuestionAdd setOpen={setOpen} Open={Open} setquestions={setquestions} />}
            <Popups style={{maxWidth:600,}}>
                <h1>{t("task_start_send")}</h1>

                <nav className='tabs'>
                    <a onClick={() => checkValues(1)} className={tab == 1 ? "ck" : "none"}>{t("tasks_send_op_1")}</a>
                    <a onClick={() => checkValues(2)} className={tab == 2 ? "ck" : "none"}>{t("tasks_send_op_2")}</a>
                    <a onClick={() => checkValues(3)} className={tab == 3 ? "ck" : "none"}>{t("tasks_send_op_3")}</a>
                    <a onClick={() => checkValues(4)} className={tab == 4 ? "ck" : "none"}>{t("tasks_send_op_4")}</a>
                </nav>

                {tab == 1 && <div className='popupBody' style={{padding:15}}>

                    <div style={{display:"flex", justifyContent:"flex-end", marginBottom:20}}>
                        <button onClick={() => setOpen(true)} className='btn gray newq'>{t("task_new_add_question")}</button>
                    </div>
                    <div className='newQuestionsBox' style={{marginTop:5}}>
                        
                        <table className='table h-border same-color'>
                            <thead>
                                <tr>
                                    <td style={{width:30}}>#</td>
                                    <td className='text-right'>{t("task_question")}</td>
                                    <td style={{width:110}}>{t("task_type")}</td>
                                    <td style={{width:125}}>{t("edit")}</td>
                                </tr>
                            </thead>

                            <SortableContainerElem helperClass="sortabled" pressDelay={200} onSortEnd={(oldIndex, newIndex) => saveSort(oldIndex, newIndex)}>

                                {questions?.length ? <tbody>

                                    {questions?.map((v, k) => {
                                        return (
                                           <SortableItem key={`item-${k}`} index={k} v={v} k={k} />
                                        );
                                    })}
                                </tbody>: false}
                            </SortableContainerElem>


                        </table>
                        
                        {!questions?.length ? <div className='no_data'>{t("error",  { returnObjects: true })[1]}</div>: false}

                    </div>
                </div>}


                {tab == 2 &&  <div className='popupBody sendTaskBox ' style={{padding:15}}>
                    <Input 
                        placeholder={" "}
                        validate={true}
                        title={t("task_new_name")}
                        onChange={(d) => setvalues(p => ({
                            ...p,
                            title:d, 
                        }))}
                        value={values?.title}
                    />
                    

                    <ClassesDropdown 
                        click={params?.task ? true : false}
                        validate={true}
                        type="own"
                        onChange={(d) => setvalues(p => ({
                            ...p,
                            classes:d,
                        }))}
                        value={values?.classes}
                        
                    />

                    {students?.length ? <MultiSelecNew
                        // click={click}

                        title={t("task_start_send")} 
                        values={students}
                        onChange={(v) => setvalues(p => ({
                            ...p,
                            students:v,
                        }))}
                        value={values?.students}
                        style={{maxWidth:400}}
                    />: false}

                    <SelectBox 
                        title={t("tasks_send_timer")}
                        top={true}
                        onChange={(d) => setvalues(p => ({
                            ...p,
                            timer:d, 
                        }))}
                        values={timingLimit}
                        value={values?.timer}
                    /> 

                    <SelectBox 
                        title={t("tasks_check_nswers")}
                        top={true}
                        onChange={(d) => setvalues(p => ({
                            ...p,
                            answers_result:d, 
                        }))}
                        values={[
                            {
                                name: t("tasks_check_nswers_1"),
                                val: 0,
                            },
                            {
                                name: t("tasks_check_nswers_2"),
                                val: 1,
                            }
                        ]}
                        value={values?.answers_result}
                    />

                    <div style={{display:"flex", alignItems:"center", gap:0, maxWidth:400}}>

                        <Input 
                            placeholder={" "}
                            title={t("tasks_send_show_date")}
                            type='datetime-local'
                            onChange={(d) => setvalues(p => ({
                                ...p,
                                start_date:d, 
                            }))}
                            value={values?.start_date}
                            style={{flex:1}}
                        />
                        <Input 
                            placeholder={" "}
                            title={t("tasks_send_show_enddate")}
                            type='datetime-local'
                            onChange={(d) => setvalues(p => ({
                                ...p,
                                end_date:d, 
                            }))}
                            value={values?.end_date}
                            style={{flex:1}}
                        />
                    </div>
                    
                </div>}

                {tab == 4 && <div className='popupBody sendTaskBox' style={{padding:15}}>
                    <Input 
                        placeholder={" "}
                        type="textarea"
                        title={t("tasks_send_notes")}
                        onChange={(d) => setvalues(p => ({
                            ...p,
                            notes:d, 
                        }))}
                        value={values?.notes}
                        style={{maxWidth:"100%"}}
                    />
                </div>}

                {tab == 3 && <div className='popupBody sendTaskBox' style={{padding:15}}>
                    <RichText 
                        toolbar='bold italic forecolor styles | bullist numlist | media imgs mp3 code' 
                        height={400}
                        onChange={(d) => setvalues(p => ({
                            ...p,
                            story:d,
                        }))}
                        value={values?.story}
                    />
                </div>}

                <div className='taskBtnSend'>
                    <button className='btn prev' onClick={() => nextBack(true)}>{t("prev")}</button>
                    {tab == maxTabs ? 
                        <button className='btn send' onClick={submit}>{t("tasks_send_now")}</button>
                        :
                        <button className='btn send' onClick={() => nextBack()}>{t("next")}</button>
                    }
                </div>
            </Popups>
        </>
    )
}
